export const CREATERULE_TEST_IDS = {
    ADD_DURATION_CHECKBOX: "createRule_addDurationCheckbox",
    DURATION_NUMBER_INPUT: "createRule_durationNumberInput",
    DURATION_UNIT_DROPDOWN: "createRule_durationUnitDropdown",
    TIME_PARAMETER_DROPDOWN: "createRule_timeParameterDropdown",
    START_TIME_DROPDOWN: "createRule_startTimeDropdown",
    END_TIME_DROPDOWN: "createRule_endTimeDropdown",
    TIME_ZONE_DROPDOWN: "createRule_timeZoneDropdown",
    DAY_OF_WEEK: "createRule_dayOfWeek",
    SETTINGS_LINK: "createRule_settingsLink",
    BACK_BUTTON: "createRule_backButton",
    NEXT_BUTTON: "createRule_nextButton",
    MODAL_CLOSE_BUTTON: "createRule_modalCloseButton",
    MODAL_CONTINUE_BUTTON: "createRule_modalContinueButton",
    MODAL_CANCEL_BUTTON: "createRule_modalCancelButton",
    ALERT_NAME_INPUT: "createRule_alertNameInput",
    APP_DROPDOWN: "createRule_appDropdown",
    SITE_DROPDOWN: "createRule_siteDropdown",
    ROI_ALERTS_BUTTON: "createRule_roiAlertsButton",
    ROI_SELECT_RADIO: "createRule_roiSelectRadio",
    SUBAREA_ROI_SELECT_RADIO: "createRule_subareaRoiSelectRadio",
    AREA_SELECT_RADIO: "createRule_areaSelectRadio",
    SUBAREA_SELECT_RADIO: "createRule_subAreaSelectRadio",
    LOCATION_DROPDOWN: "createRule_locationDropdown",
    FIXEDAREA_LOCATION_DROPDOWN: "createRule_fixedAreaLocationDropdown",
    TIMEFRAME_RADIO_GROUP: "createRule_timeFrameRadioGroup",
    SEVERITY_DROPDOWN: "createRule_severityDropdown",
    NOTIFICATION_GROUP_CHECKBOX: "createRule_notificationGroupCheckbox", 
    NOTIFICATION_GROUP_CHECKBOX_EDIT: "createRule_notificationGroupCheckboxEdit",
    SMS_NOTIFICATION_CHECKBOX: "createRule_smsNotificationCheckbox",
    EMAIL_NOTIFICATION_CHECKBOX: "createRule_emailNotificationCheckbox",
    SMS_NOTIFICATION_CHECKBOX_EDIT: "createRule_smsNotificationCheckboxEdit",
    EMAIL_NOTIFICATION_CHECKBOX_EDIT: "createRule_emailNotificationCheckboxEdit",
    TRIGGER_OPERATOR_DROPDOWN: "createRule_triggerOperatorDropdown",
    TRIGGER_NUMBER_INPUT: "createRule_triggerNumberInput",
    TRIGGER_COOLDOWN_CHECKBOX: "createRule_triggerCooldownCheckbox",
    TRIGGER_COOLDOWN_NUMBER_INPUT: "createRule_triggerCooldownNumberInput",
    TRIGGER_OPERATOR_DROPDOWN: "createRule_triggerOperatorDropdown", 
    TRIGGER_UNIT_DROPDOWN: "createRule_triggerUnitDropdown",
    BULK_RULE_CREATE_BUTTON: "bulkRule_createButton",
    BULK_RULE_SEARCH_INPUT : "bulkRule_searchInput",
};